export enum SectionName {
  Transversal = 'Transverse',
  Product = 'Produits',
  StockAndQuota = 'Stock et quota',
  Payment = 'Paiement CB',
  Validation = 'Validation',
  Delivery = 'Livraison',
  Marketing = 'Personnalisation',
  Users = 'Utilisateurs',
  Toggle = 'Activation / Désactivation',
}
